<template>
  <div class="tekenaar">
    <div class="item opdrlistopdrachtnummer" style="opacity: 1;min-width: 160px;max-width:200px;">
      <span style="background-color: red; color: white; font-weight: 500; margin-rigth: 16px; border-radius: 100px; display: block; padding: 4px; margin-right: 8px;" v-if="opdrachts.gearchiveerd && !opdrachts.gearchiveerd?.approved && opdrachts.status[opdrachts.status?.length - 1].event !== 2"></span>

      <span class="tekst" style="font-weight:600;">CDT.{{ new Date(opdrachts.metadata.createdAt.toDate()).getFullYear() }}.{{ new Date(opdrachts.metadata.createdAt.toDate()).getMonth() + 1 }}.{{ opdrachts.metadata.opdrachtNummer }}</span>
    </div>
    <div class="item opdrlistbedrijfsnaam" style="min-width: 200px;">
      <span class="tekst">{{ opdrachts.opdrachtgever.bedrijfsnaam }}</span>
    </div>
    <div class="item opdrlistdisciplines" style="min-width:200px;">
      <span
        class="disciplinee"
        :class="{
          pastel1: opdrachts.aanvraag.discipline == 'Bouwkunde',
          pastel2: opdrachts.aanvraag.discipline == 'Werktuigbouwkunde',
          pastel3: opdrachts.aanvraag.discipline == 'Installatietechniek',
          pastel4: opdrachts.aanvraag.discipline == 'Elektrotechniek',
          pastel5: opdrachts.aanvraag.discipline == 'Huisvesting',
          pastel6: opdrachts.aanvraag.discipline == 'Plattegronden',
          pastel7: opdrachts.aanvraag.discipline == 'Concepten - 3D Print',
          pastel8: opdrachts.aanvraag.discipline == 'Brandpreventie',
          pastel9: opdrachts.aanvraag.discipline == 'Nen2580'
        }"
        >{{ opdrachts.aanvraag.discipline }}</span
      >
    </div>
    <div class="item opdrliststatus" style="max-width:190px;">
      <span v-if="opdrachts.geannuleerd != true && opdrachts.onhold != true" class="tekst">{{ opdrachts.statusString }}</span>
      <span v-if="opdrachts.geannuleerd == true" class="tekst" style="color:#F1646C;">Geannuleerd</span>
      <span v-if="opdrachts.onhold == true && !opdrachts.geannuleerd" class="tekst" style="color:#FF9326;">On Hold</span>
      <div v-if="opdrachts.statusString == 'In behandeling' && opdrachts.geannuleerd != true" style="width:10px;height:10px;background-color:green;border-radius:100px;display:inline-block;margin-left:5px;"></div>
    </div>

    <div v-if="gekoppeldeTekenaar" class="item opdrlisttekenaar tekenaarsProfile" style="min-width:200px;">
      <img width="30" :src="gekoppeldeTekenaar.userProfile.profilePictureURL" alt="" />
      <span>{{ gekoppeldeTekenaar.userProfile.voornaam }} {{ gekoppeldeTekenaar.userProfile.achternaam }}</span>
    </div>
    <div v-else class="item opdrlisttekenaar" style="min-width:200px;">
      <span v-if="opdrachts.tekenaarsid" class="tekst">{{ teknaam(opdrachts.tekenaarsid) }}</span>
    </div>
    <div class="item opdrlistvoortgang">
      <VoortgangsBalk :opdracht="opdracht" />
    </div>
  </div>
</template>

<script>
import VoortgangsBalk from "@/components/v2/voortgangsBalk"
import store from "@/store"
import { computed } from "@vue/runtime-core"

import { useStore } from "vuex"

export default {
  props: {
    opdracht: Object
  },
  components: {
    VoortgangsBalk
  },
  setup(props) {
    const store = useStore()

    const gekoppeldeTekenaar = computed(() => {
      if (!props.opdracht.afhandeling?.tekenaar) return false

      let userAccounts = store.state.userAccounts

      return userAccounts.find(e => e.id === props.opdracht?.afhandeling?.tekenaar)
    })

    return {
      gekoppeldeTekenaar
    }
  },
  computed: {
    opdrachts() {
      return this.opdracht
    },
    opdrachtid() {
      return this.opdracht.id
    },
    inBehandeling() {
      return this.opdrachts.statusString !== "Nieuw"
    },
    discipliness() {
      let b = []
      this.tekenaars.disciplines.forEach(element => {
        b.push(element.charAt(0))
      })
      return b
    }
  },
  methods: {
    teknaam(e) {
      const tekenaarsnaam = store.state.tekenaars.filter(tekenaar => tekenaar.id == e)
      if (tekenaarsnaam != undefined) {
        return tekenaarsnaam[0]?.voornaam + " " + tekenaarsnaam[0]?.achternaam
      }
      if (tekenaarsnaam == undefined) {
        return "Geen tek"
      }
    }
  }
}
</script>

<style lang="sass" scoped>

.tekenaarsProfile
  img
    object-fit: cover
    object-position: center
    background-color: grey
    border-radius: 100%
    width: 26px
    height: 26px
    margin-right: 6px

.jijTag
  position: absolute
  top: 50%
  left: -5px
  box-shadow: 0 0 0 4px #eff2f5
  transform: translateY(-50%)
  width: 10px
  height: 10px
  border-radius: 100%
  background-color: #00ca65

.wijTag
  position: absolute
  top: 50%
  left: -5px
  box-shadow: 0 0 0 4px #eff2f5
  transform: translateY(-50%)
  width: 10px
  height: 10px
  border-radius: 100%
  background-color: #1b6dff
</style>

<style scoped>
.disciplinee {
  background-color: #e4ecfa;
  border-radius: 100px;
  padding: 5px 10px;
  display: inline;
  /* display: flex;
        align-items: center;
        justify-content: center; */
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  margin-right: 7px;
  /* border: 2px solid white; */
}

.circle {
  width: 20px;
  height: 20px;
  background-color: #b8c3d5;
  border-radius: 100px;
}

.voltooid {
  background-color: #3076ea;
}

.tekenaar {
  background-color: #fff;
  padding: 25px;
  height: 60px;
  display: flex;
  position: relative;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  font-size: 15px;
  border-bottom: 1px solid #c5d8e3;
  border-left: 1px solid #c5d8e3;
  border-right: 1px solid #c5d8e3;
}

.tekenaar:hover {
  background-color: #ecf3fc;
  /* color: #fff; */
}
.item {
  color: #0b1125;
  display: flex;
  overflow: hidden;
  align-items: center;
  min-width: 160px;
  width: 25%;
  overflow: visible;
}

.tekst {
  white-space: nowrap;
}

.discipline {
  background-color: #e4ecfa;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin-right: -4px;
  font-size: 11px;
  color: #697a95;
  border: 2px solid white;
}
</style>
